﻿import {Grid} from "@mui/material";
import {ComponentPropsWithoutRef} from "react";

type SortFilterRowContainerProps = ComponentPropsWithoutRef<'div'> & {
}

const SortFilterRowContainer = (props: SortFilterRowContainerProps) => {
  return <Grid container mt={0.5} spacing={2} justifyContent={'end'} {...props} />
}

export { SortFilterRowContainer };
